import * as React from 'react';

import Button from '../../Button';
import {Modal} from '../../Modal';
import './PosterCreatorModal.css';
import {ImageFileTypes} from "../../../infrastructure/ImageFileTypes";

export interface PosterCreatorProps {
  show: any;
  onClose: any;
  onSubmit(iconName: string, formData: FormData): void;
}

export interface PosterCreatorState {
  posterImageName: string;
  imageFormData: FormData;
  hasRequiredFields: boolean;
}

export default class PosterCreatorModal extends React.Component<PosterCreatorProps, PosterCreatorState> {

  constructor(props: PosterCreatorProps) {
    super(props);
    this.state = {
      posterImageName: "",
      imageFormData: new FormData(),
      hasRequiredFields: false
    };
  }

  closeModal() {
      this.setState({
      });
      this.props.onClose();
  }

  checkForValidInput() {
    this.setState({
      hasRequiredFields:
        this.state.posterImageName.length > 0
        && this.state.imageFormData.get(ImageFileTypes.POSTER_IMAGE) != null
        && this.state.imageFormData.get(ImageFileTypes.POSTER_IMAGE_WEB) != null
    });
  }

  handleNameChange(text: string) {
    this.setState({
      posterImageName: text
    }, () => this.checkForValidInput());
  }

  handleImageChange(imageId: string, selectorFiles: FileList | null)
  {
    if (selectorFiles != null) {
      for (var key in selectorFiles) {
        if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
          var imageFormData = this.state.imageFormData
          imageFormData.set(imageId, selectorFiles[key]);
          this.setState({
            imageFormData: imageFormData
          }, () => this.checkForValidInput());
          break;
        }
      }
    }
  }

  render() {

    return (
        <Modal show={this.props.show}
          onClose={() => {this.closeModal();}}
        >
            <Modal.Header>
                <div className="coverModalHeaderContainer">
                  <div>
                    <Modal.Title>
                        <h5>
                            {'Upload Poster Images'}
                        </h5>
                    </Modal.Title>
                    <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
                  </div>
                  <div>
                      All Images Must Be JPEGs
                  </div>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="coverInputContainer">
                    <label>
                        Poster Image Name (ex: "Seed X")
                    </label>
                  <input
                    className="coverModelInput"
                    type="text"
                    value={this.state.posterImageName}
                    onChange={(event) => this.handleNameChange(event.target.value)}
                  />
                </div>
                <div className="coverInputContainer">
                    <label>
                        Poster Image (36" x 24", 10800x7200 pixels)
                    </label>
                    <input type="file" className="filepond" onChange={(e) => this.handleImageChange(ImageFileTypes.POSTER_IMAGE, e.target.files)} />
                </div>
                <div className="coverInputContainer">
                    <label>
                        Poster Web Image (36" x 24", 2592x1728 pixels)
                    </label>
                    <input type="file" className="filepond" onChange={(e) => this.handleImageChange(ImageFileTypes.POSTER_IMAGE_WEB, e.target.files)} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    disabled={!this.state.hasRequiredFields}
                    onClick={() => {
                        if (this.state.posterImageName.length > 0) {
                            this.props.onSubmit(this.state.posterImageName, this.state.imageFormData);
                            this.setState({
                                posterImageName: "",
                                imageFormData: new FormData(),
                                hasRequiredFields: false
                                },);
                            }
                        }
                    }
                >
                    Upload
                </Button>
            </Modal.Footer>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/PosterCreatorModal/PosterCreatorModal.tsx